import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Gift, Copy, Share2 } from "lucide-react";

export default function ReferralCard() {
  const [referral, setReferral] = useState(null);

  useEffect(() => {
    api.get("/me/referral").then(r => setReferral(r.data)).catch(() => {});
  }, []);

  if (!referral) return null;

  const link = `${window.location.origin}/register?ref=${referral.referral_code}`;
  const shareText = `Design your dream home with HouseDesignWala! Use my code ${referral.referral_code} to get 10% off your first order: ${link}`;

  const copyCode = () => {
    navigator.clipboard.writeText(referral.referral_code);
    toast.success("Code copied!");
  };

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, "_blank");
  };

  return (
    <div className="bg-gradient-to-br from-[#1a3c5e] to-[#0f2438] rounded-2xl p-5 text-white" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-1">
        <Gift className="w-5 h-5 text-[#F7941D]" />
        <h3 className="font-display font-bold">Refer a friend, they get 10% off</h3>
      </div>
      <p className="text-sm text-white/70 mb-3">Share your code — when a friend signs up with it, they get a welcome discount.</p>
      <div className="flex items-center gap-2 flex-wrap">
        <div className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 font-mono font-bold tracking-wider" data-testid="referral-code">
          {referral.referral_code}
        </div>
        <button onClick={copyCode} data-testid="referral-copy" className="px-3 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-sm font-semibold flex items-center gap-1.5">
          <Copy className="w-3.5 h-3.5" /> Copy
        </button>
        <button onClick={shareWhatsApp} data-testid="referral-share-wa" className="px-3 py-2 bg-[#25D366] hover:bg-[#1ea855] rounded-lg text-sm font-semibold flex items-center gap-1.5">
          <Share2 className="w-3.5 h-3.5" /> Share on WhatsApp
        </button>
      </div>
      {referral.uses > 0 && (
        <p className="text-xs text-white/60 mt-2">{referral.uses} friend{referral.uses > 1 ? "s have" : " has"} joined using your code so far.</p>
      )}
    </div>
  );
}
